<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLAttributes } from 'svelte/elements';
  import { cn } from '../lib/cn';

  let { class: className, children, ...rest }: HTMLAttributes<HTMLSpanElement> & { children?: Snippet } = $props();
</script>

<span
  class={cn(
    'inline-flex items-center rounded-md border border-border bg-surface-3 px-2 py-0.5 text-xs font-medium text-text-2',
    className as string | undefined,
  )}
  {...rest}>{@render children?.()}</span>
